import { render, staticRenderFns } from "./ViewPurchaseOrdersProducts.vue?vue&type=template&id=3944ce8a&lang=pug&"
import script from "./ViewPurchaseOrdersProducts.vue?vue&type=script&lang=js&"
export * from "./ViewPurchaseOrdersProducts.vue?vue&type=script&lang=js&"
import style0 from "./ViewPurchaseOrdersProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports